import React, { useState, useMemo } from "react";
import { useLang } from "../i18n/LanguageContext";
import ActivityCard from "../components/ActivityCard";
import Reveal from "../components/Reveal";
import { ACTIVITIES, CATEGORIES } from "../data/mock";

const HEADER_IMG = "https://images.pexels.com/photos/20510655/pexels-photo-20510655.jpeg";

const Activities = () => {
  const { t, lang } = useLang();
  const [cat, setCat] = useState("all");

  const filtered = useMemo(
    () => (cat === "all" ? ACTIVITIES : ACTIVITIES.filter((a) => a.category === cat)),
    [cat]
  );

  return (
    <div className="bg-[#f7f5ef] min-h-screen">
      {/* Page header */}
      <section className="relative pt-40 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src={HEADER_IMG} alt="Activities" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#1c221e]/65" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 text-center">
          <Reveal>
            <p className="text-white/80 text-xs tracking-[0.25em] uppercase mb-4">{t.activities.eyebrow}</p>
            <h1 className="font-serif text-5xl md:text-6xl text-white mb-5">{t.activities.allTitle}</h1>
            <p className="text-white/80 max-w-xl mx-auto">{t.activities.allSubtitle}</p>
          </Reveal>
        </div>
      </section>

      {/* Filters */}
      <div className="sticky top-[64px] z-30 bg-[#f7f5ef]/95 backdrop-blur-md border-b border-[#e6e3d9]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-4 flex gap-2.5 overflow-x-auto no-scrollbar">
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              onClick={() => setCat(c.id)}
              className={`whitespace-nowrap px-5 py-2.5 rounded-full text-[12px] tracking-[0.08em] uppercase font-medium transition-all ${
                cat === c.id
                  ? "bg-[#7c8f74] text-white"
                  : "bg-white text-[#5c6b54] border border-[#e0ddd2] hover:border-[#7c8f74]"
              }`}
            >
              {c.label[lang]}
            </button>
          ))}
        </div>
      </div>

      {/* Grid */}
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          {filtered.length === 0 ? (
            <p className="text-center text-[#6b7166] py-20">{t.activities.empty}</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
              {filtered.map((a, i) => (
                <Reveal key={a.id} delay={(i % 3) * 90}>
                  <ActivityCard activity={a} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Activities;
